module.exports = __webpack_public_path__ + "static/media/address.047f1be9.svg";